import { useTrackNavigationLink } from '@hooks/use-track-navigation-link'
import { ENHANCED_COMPONENT_ROLE } from '@ui/enhanced-components/types'
import { Link } from 'gatsby'
import queryString from 'query-string'
import { type SyntheticEvent } from 'react'

import { useIsIframe } from '../../../plugins/gatsby-plugin-espace-client'

type UseInternalLinksReturn = {
  to: string
  onClick: (event: SyntheticEvent) => void
  component: typeof Link
  'data-role': ENHANCED_COMPONENT_ROLE
}

export const useInternalLinkProps = (slug: string): UseInternalLinksReturn => {
  const trackNavigationLink = useTrackNavigationLink()
  const isIframe = useIsIframe()
  const url = queryString.stringifyUrl({
    url: slug,
    query: {
      iframe: true,
    },
  })

  return {
    to: isIframe ? url : slug,
    onClick: trackNavigationLink,
    component: Link,
    'data-role': ENHANCED_COMPONENT_ROLE.SECONDARY,
  }
}
